import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=25288256&scoped=true&"
import script from "./Challenges.vue?vue&type=script&lang=ts&"
export * from "./Challenges.vue?vue&type=script&lang=ts&"
import style0 from "@/markdown.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Challenges.vue?vue&type=style&index=1&id=25288256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25288256",
  null
  
)

export default component.exports